export default "__VITE_ASSET__ecbe6dac__"